// extracted by extract-css-chunks-webpack-plugin
module.exports = {"form-content":"form-content_3Pop_","close_icon":"close_icon_1GG8b"};